import Footer from './footer.vue'

Footer.insatll = Vue => {
  Vue.component(Footer.name, Footer)
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js